import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import { Button } from 'components/ui/Button';

import Styles from './QRCode.module.css';
import { notification } from 'antd';

// eslint-disable-next-line react/prop-types
const QRCodeComponent = ({ url, siren, isSiretCorrect }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!url || !canvasRef.current) return;

    QRCode.toCanvas(canvasRef.current, url, {
      width: 200,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#ffffff',
      },
    });
  }, [url]);

  const handleDownloadQRCode = () => {
    if (!isSiretCorrect) {
      notification.error({ message: 'Code SIRET incorrect' });
      return;
    }

    const canvas = canvasRef.current;
    if (!canvas) return;

    const link = document.createElement('a');
    link.download = `qrcode_rne_${siren}.png`;
    link.href = canvas.toDataURL();
    link.click();
  };

  const handleDownloadAttestationRNE = () => {
    if (!isSiretCorrect) {
      notification.error({ message: 'Code SIRET incorrect' });
      return;
    }

    const link = document.createElement('a');
    link.download = `attestation_RNE_${siren}.pdf`;
    link.href = url;
    link.click();
  };

  return (
    <>
      <div className={Styles.QRCodeWrapper}>
        <canvas ref={canvasRef} />
        <Button
          variant="secondary"
          className={Styles.downloadButton}
          onClick={handleDownloadAttestationRNE}
        >
          Télécharger votre attestation d&apos;immatriculation RNE
        </Button>
      </div>
      <div className={Styles.QRCodeWrapper}>
        <Button
          variant="secondary"
          className={Styles.downloadButton}
          onClick={handleDownloadQRCode}
        >
          Télécharger le QR code RNE
        </Button>
      </div>
    </>
  );
};

export default QRCodeComponent;
